import type { FC } from "react"
import { createContext, useContext } from "react"

import type { InventoryByProductItem } from "@/graphql/codegen/graphql"

interface ProductInventoryProviderProps {
  inventory: InventoryByProductItem
  children: React.ReactNode
}

const ProductInventoryContext = createContext<InventoryByProductItem | null>(null)

export const ProductInventoryProvider: FC<ProductInventoryProviderProps> = ({ inventory, children }) => (
  <ProductInventoryContext.Provider value={inventory}>{children}</ProductInventoryContext.Provider>
)

export const useProductInventoryContext = (): InventoryByProductItem => {
  const context = useContext(ProductInventoryContext)

  if (!context) {
    throw new Error("useProductInventoryContext must be used within a ProductInventoryProvider")
  }

  return context
}
